import type {ReactElement, ReactNode} from 'react';
import Popup from '@components/Popup';
import {clsx} from 'clsx';
import QuickFade from '@components/Animation/QuickFade/QuickFade';
import styles from './index.module.scss';

interface Props {
    children: ReactNode;
    isOpen: boolean;
    isCentered?: boolean;

    onClose?(): void;
}

export default function DialogBase(props: Props): ReactElement<Props> {
    const classes = clsx({
        [styles.background]: true,
        [styles.centered]: props.isCentered,
    });

    return (
        <QuickFade in={props.isOpen} unmountOnExit>
            <Popup>
                <div className={classes} onClick={props.onClose}>
                    {props.children}
                </div>
            </Popup>
        </QuickFade>
    );
}

DialogBase.defaultProps = {
    isCentered: false,
    onClose() {
        /* do nothing */
    },
};
